import { Component, OnInit, Input } from '@angular/core';
import { AlertBoxType } from './alertboxtype';

@Component({
  selector: 'app-alert-box',
  templateUrl: './alert-box.component.html',
  styleUrls: ['./alert-box.component.scss']
})
export class AlertBoxComponent implements OnInit {

  public alertCssClass = '';
  public iconClass = '';

  @Input()
  set type(type: AlertBoxType) {
    switch (type) {
      case AlertBoxType.info:
        this.alertCssClass = 'alert-info';
        this.iconClass = 'fa-info-sign';
        break;
      case AlertBoxType.warning:
        this.alertCssClass = 'alert-warning';
        this.iconClass = 'fa-bell-alt';
        break;
      case AlertBoxType.error:
        this.alertCssClass = 'alert-danger';
        this.iconClass = 'fa-ban-circle';
        break;
      case AlertBoxType.success:
        this.alertCssClass = 'alert-success';
        this.iconClass = 'fa-ok-sign';
        break;
    }
  }



  constructor() { }

  ngOnInit(): void {
  }

}
